import React from 'react';
import './Clientes-Modal.css';
import Video from './assets/Las_Nieves/Video.mp4';

const LasNieves = () => {
  return (
    <div className="container">
      <h2>
       ✅ Proyecto: Casa Cural Nuestra Señora de las Nieves 🌞✨{' '}
        
      </h2>
      <p>
              <video controls>
          <source src={Video} type="video/mp4" />
          Tu navegador no soporta la reproducción de video.
        </video>
       <span className="highlight"> Energía limpia al servicio de la comunidad: sostenibilidad aplicada a los espacios de misión y servicio.</span>

<br/><br/>En la Casa Cural Nuestra Señora de las Nieves, lugar de trabajo pastoral y reuniones comunitarias, instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 7 kWp, compuesto por 10 paneles solares de alta eficiencia y un inversor multicanal de 8 kW.

<br/><br/>Esta tecnología permite gestionar de manera segura y estable las cargas eléctricas del lugar, optimizando el rendimiento del sistema y garantizando energía constante para las actividades diarias del despacho parroquial y el uso residencial del espacio.

<br/>Los objetivos de este proyecto fueron:<br/><br/>

✔ Reducir los costos asociados al consumo eléctrico de la Casa Cural
<br/>✔ Implementar una solución sostenible y responsable con el medio ambiente
<br/>✔ Garantizar energía continua para iluminación, equipos y actividades de servicio parroquial

<br/><br/>Hoy, la Casa Cural de Nuestra Señora de las Nieves genera su propia energía limpia, disminuyendo mensualmente sus costos de facturación eléctrica y permitiendo que más recursos sean destinados a las necesidades de la comunidad.

<br/><br/>Esta instalación demuestra que la sostenibilidad y la misión pastoral pueden integrarse de manera armónica, convirtiendo este espacio en un referente de responsabilidad ambiental dentro de la parroquia.

<br/><br/><span className='highlight'> Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e Innovación, ofreciendo:</span>

<br/><br/>🔧 Soporte técnico y mantenimiento preventivo.
<br/>🔧 Monitoreo del sistema para garantizar máxima eficiencia energética.
<br/>🔧 Instalación estructural segura, diseñada para prolongar la vida útil del sistema y facilitar su mantenimiento.
<br/>🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo.
<br/>🔧 Acompañamiento presencial de nuestros ingenieros durante y después de la instalación.

<br/><br/>Una decisión inteligente que une sostenibilidad, ahorro y propósito al servicio de la comunidad.
      </p>
    </div>
  );
};

export default LasNieves;
